<div class="page-title-area item-bg2">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content">
                    <h2>{{project.name}}</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Projects Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="project-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="image-sliders owl-carousel owl-theme">
                    <div class="project-details-image">
                        <img src="{{environment.ImageApiPath +'/'+ this.project?.attachment?.name}}" alt="{{project?.name}}">
                    </div>

                </div>
            </div>
            <div class="col-lg-6 col-md-6">
                <div class="projects-details-desc" [innerHTML]="project?.descrption" >

                </div>
            </div>
            <div class="col-lg-12 col-md-6">
                <div class="projects-details-desc">
            <div class="project-details-info">

                <div class="single-info-box">
                    <h4>Project Name</h4>
                    <span>{{project.name}}</span>
                </div>
                <div class="single-info-box">
                    <h4>Category</h4>
                    <span>{{project.category.name}}</span>
                </div>
                <div class="single-info-box">
                    <h4>Date</h4>
                    <span>{{project.createdDate | date:"dd-MM-yyyy"}}</span>
                </div>

                <div class="single-info-box">
                    <a href="{{project.link}}" target="_blank" class="default-btn">Live Preview</a>
                </div>
            </div>
            </div>
            </div>
        </div>
    </div>
</section>
